import {WebsiteEffects} from "./website.effect";
import {TenWebProductEffect} from './ten-web-product.effect';
import {BackupEffect} from './backup.effect';
import {JobEffect} from './job.effect';
import {PerformanceEffect} from './performance.effect';
import {WebsitePluginEffects} from "./website-product.effect";
import {ActivityNotificationsEffects} from "./activity-notifications.effect";
import {UserSummariesEffects} from "./user-summaries.effect";
import {ActivitiesEffects} from './activities.effect';
import {UserEffects} from "./user.effect";
import {UserLocalStorageEffect} from "./user-local-storage.effect";
import {OngoingActivitiesEffects} from "./ongoing-activities.effect";
import {HostingDomainsEffects} from "./hosting-domains.effect";
import {HostingZonesEffects} from "./hosting-zones.effect";
import {HostingRedirectsEffects} from "./hosting-redirects.effect";
import {HostingLogsEffects} from "./hosting-logs.effect";
import {HostingInfoEffects} from "./hosting-info.effect";
import {SecurityEffect} from './security.effect';
import {BackupLimitsEffect} from "./backup-limits.effect";
import {HostingResourcesEffect} from "./hosting-resources.effect";
import {HostingVisitsEffect} from "./hosting-visits.effect";
import {BuilderTemplatesEffects} from "./builder-templates.effect";
import {RouterEffects} from "./router.effect";
import {HostingCertificatesEffects} from "./hosting-certificates.effect";
import {HostingSettingsEffects} from "./hosting-settings.effect";
import {HostingCacheExcludeEffects} from "./hosting-cache-exclude.effect";
import {WebsiteTagsEffects} from "./website-tags.effect";
import {TourSectionEffects} from "./tour-section.effect";
import {WorkspaceEffects} from "./workspace.effect";
import {WorkspaceSwitcherEffects} from "./workspace-switcher.effect";
import {BoosterEffect} from "./booster.effect";
import {AiBuilderEffects} from "./ai-builder.effect";
import {BoosterDataEffect} from "./booster-data.effect";
import {CloudflareDataEffects} from "./cloudflare-data.effect";
import {CacheRulesEffects} from "./cache-rules.effect";
import {BandwidthEffects} from "./bandwidth.effect";
import {TroubleShootEffect} from "./troubleshoot.effect";
import {ImageOptimizerEffect} from "./image-optimizer.effect";
import {BoosterAdvancedSettingsEffect} from "./booster-advanced-settings.effect";
import {UserPaymentMethodsEffect} from "./user-payment-methods.effect";
import {EcommerceEffect} from "./ecommerce.effect";
import {EcommerceOrdersEffect} from "./ecommerce-orders.effect";
import {EcommerceCustomersEffect} from "./ecommerce-customers.effect";
import {EcommerceProductEffect} from "./ecommerce-product.effect";
import {HostingPhpConfigsEffect} from "./hosting-php-configs.effect";
import {UserPaymentsEffect} from "./payments.effect";
import {EcommerceSetupEffect} from "./ecommerce-setup-list.effect";
import {EcommerceSettingsEffect} from "./ecommerce-settings.effect";
import {EcommerceMerchantEffect} from "./ecommerce-merchant.effect";
import {EcommerceNavigationEffect} from "./ecommerce-navigation.effect";
import {EcommercePaymentMethodsEffect} from "./ecommerce-payment-methods.effect";
import {EcommercePerformanceEffect} from "./ecommerce-performance.effect";
import {EcommerceAnalyticsEffect} from "./ecommerce-analytics.effect";
import {EcommerceTaxSettingsEffect} from "./ecommerce-tax-settings.effect";
import {EcommerceTaxRatesEffect} from "./ecommerce-tax-rates.effect";
import {EcommerceGeneralSettingsEffect} from "./ecommerce-general-settings.effect";
import {EcommerceEmailsListEffect} from "./ecommerce-emails-list.effect";
import {EcommerceEmailsSettingsEffect} from "./ecommerce-emails-settings.effect";
import {EcommercePerformanceReportEffect} from "./ecommerce-performance-report.effect";
import {EcommercePerformanceReportNetSalesEffect} from "./ecommerce-performance-net-sales.effect";
import {BackupListEffect} from "./backup-list.effect";
import {EcommerceTaxClassesEffect} from "./ecommerce-tax-classes.effect";
import {BackupSettingsEffect} from "./backup-settings.effect";
import {EcommerceRefundsEffect} from "./ecommerce-refunds.effect";
import {EcommercePublicKeyEffect} from "./ecommerce-public-key.effect";
import {WebsitesZoneEffect} from "./websites-zone.effect";
import {TenWebApiEffects} from "./10web-api.effects";
import {WordpressWPVersionEffect} from "./website-wp-version.effect";
import {UsedAiCreditsEffects} from "./used-ai-credits.effects";
import {CompanyInfoEffects} from "./company-info.effect";
import {VibeFilesEffects} from "./vibe-files.effect";
import {VibeLimitationsEffects} from "./vibe-limitations.effect";
import {DomainExpandedDataEffect} from "./domain-expanded-data.effect";

export const effects: any[] = [
    UserEffects,
    UserPaymentsEffect,
    UserLocalStorageEffect,
    UserPaymentMethodsEffect,
    WebsiteEffects,
    TenWebProductEffect,
    PerformanceEffect,
    SecurityEffect,
    BackupEffect,
    BuilderTemplatesEffects,
    BackupLimitsEffect,
    JobEffect,
    HostingResourcesEffect,
    WebsitePluginEffects,
    ActivityNotificationsEffects,
    ActivitiesEffects,
    OngoingActivitiesEffects,
    UserSummariesEffects,
    TourSectionEffects,
    HostingDomainsEffects,
    DomainExpandedDataEffect,
    HostingZonesEffects,
    HostingRedirectsEffects,
    HostingLogsEffects,
    HostingInfoEffects,
    HostingVisitsEffect,
    HostingCertificatesEffects,
    HostingSettingsEffects,
    HostingPhpConfigsEffect,
    HostingCacheExcludeEffects,
    WebsiteTagsEffects,
    RouterEffects,
    WorkspaceEffects,
    AiBuilderEffects,
    WorkspaceSwitcherEffects,
    AiBuilderEffects,
    BoosterEffect,
    BoosterDataEffect,
    BoosterAdvancedSettingsEffect,
    TroubleShootEffect,
    CloudflareDataEffects,
    CacheRulesEffects,
    BandwidthEffects,
    ImageOptimizerEffect,
    EcommerceEffect,
    EcommerceOrdersEffect,
    EcommerceCustomersEffect,
    EcommerceProductEffect,
    EcommerceSetupEffect,
    EcommerceSettingsEffect,
    EcommerceMerchantEffect,
    EcommercePaymentMethodsEffect,
    EcommercePublicKeyEffect,
    EcommercePerformanceEffect,
    EcommerceAnalyticsEffect,
    EcommerceTaxSettingsEffect,
    EcommerceTaxRatesEffect,
    EcommerceTaxClassesEffect,
    EcommerceGeneralSettingsEffect,
    EcommerceEmailsListEffect,
    EcommerceEmailsSettingsEffect,
    EcommercePerformanceReportEffect,
    EcommerceRefundsEffect,
    EcommercePerformanceReportNetSalesEffect,
    EcommerceNavigationEffect,
    BackupListEffect,
    BackupSettingsEffect,
    WebsitesZoneEffect,
    WordpressWPVersionEffect,
    TenWebApiEffects,
    UsedAiCreditsEffects,
    CompanyInfoEffects,
    VibeFilesEffects,
    VibeLimitationsEffects
];

export * from './user.effect';
export * from './user-local-storage.effect';
export * from './user-payment-methods.effect';
export * from './website.effect';
export * from './ten-web-product.effect';
export * from './builder-templates.effect';
export * from './backup.effect';
export * from './backup-limits.effect';
export * from './job.effect';
export * from './performance.effect';
export * from './security.effect';
export * from './website-product.effect';
export * from './activity-notifications.effect';
export * from './activities.effect';
export * from './ongoing-activities.effect';
export * from './user-summaries.effect';
export * from './domain-expanded-data.effect';
export * from './hosting-domains.effect';
export * from './hosting-zones.effect';
export * from './hosting-redirects.effect';
export * from './hosting-logs.effect';
export * from './hosting-info.effect';
export * from './hosting-cache-exclude.effect';
export * from './hosting-certificates.effect';
export * from './hosting-settings.effect';
export * from './hosting-resources.effect';
export * from './hosting-visits.effect';
export * from './hosting-php-configs.effect';
export * from './website-tags.effect';
export * from './router.effect';
export * from './workspace.effect';
export * from './workspace-switcher.effect';
export * from './ai-builder.effect';
export * from './booster.effect';
export * from './booster-data.effect';
export * from './booster-advanced-settings.effect';
export * from './troubleshoot.effect';
export * from './ai-builder.effect';
export * from './cloudflare-data.effect';
export * from './cache-rules.effect';
export * from './bandwidth.effect';
export * from './image-optimizer.effect';
export * from './payments.effect';
export * from './ecommerce-merchant.effect';
export * from './ecommerce-payment-methods.effect';
export * from './ecommerce-public-key.effect';
export * from './ecommerce-performance.effect';
export * from './ecommerce-analytics.effect';
export * from './ecommerce-tax-classes.effect';
export * from './ecommerce-tax-settings.effect';
export * from './ecommerce-tax-rates.effect';
export * from './ecommerce-general-settings.effect';
export * from './ecommerce-emails-list.effect';
export * from './ecommerce-emails-settings.effect';
export * from './ecommerce-refunds.effect';
export * from './ecommerce-performance-report.effect';
export * from './ecommerce-performance-net-sales.effect';
export * from './websites-zone.effect';
export * from './10web-api.effects';
export * from './website-wp-version.effect';
export * from './company-info.effect';
export * from './vibe-files.effect';
export * from './vibe-limitations.effect';

